import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { defaulMasssiveCommissionChangeDataForm, MasssiveCommissionChangeDataForm, TransportOrderFilters } from '../../../app/models/TransportOrder';
import useTransportOrderService from '../../../app/services/hooks/useTransportOrderService';
import { RouteSegment } from '../../../app/models/RouteSegment';
import { Currency } from '../../../app/models/Currency';
import { Unit } from '../../../app/models/Unit';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import MassiveCommissionChangeFilterForm from './tables/TransportOrderCommissionChangeFilter';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    filter: TransportOrderFilters;
    setFilter: React.Dispatch<React.SetStateAction<TransportOrderFilters>>;
}

const MassiveCommissionChange = ({ onSaved, onCancel, onError, filter, setFilter }: Props) => {

    const { showLoading, hideLoading } = useContext(AppContext);
    const { createMassiveCommissionChange, 
        fetchingCreateMasssiveCommissionChangeDataForm, 
        massiveCommissionChange, 
        fetchingMasssiveCommissionChangeDataForm } = useTransportOrderService();
    
    const [masssiveCommissionChangeDataForm, setMasssiveCommissionChangeDataForm] = 
        useState<MasssiveCommissionChangeDataForm>(defaulMasssiveCommissionChangeDataForm);
    const [routeSegments, setRouteSegments] = useState<RouteSegment[]>([]);
    const [currenciesCommission, setCurrenciesCommission] = useState<Currency[]>([]);
    const [unitsCommission, setUnitsCommission] = useState<Unit[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        createMassiveCommissionChange({
            onSuccess: (response: ServiceResponse) => {
                setRouteSegments(response.data.route_segments);
                setCurrenciesCommission(response.data.currency_commissions)
                setUnitsCommission(response.data.unit_commissions)

                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onCancel) onCancel();
            },
        });
    }, []);

    const update = () => {
        if (showLoading) showLoading('loading', 'Guardando cambio masivo...');

        massiveCommissionChange(masssiveCommissionChangeDataForm, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.success(response.message);
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                if (onSaved) onSaved();
                search();
            },
            onWarning: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                useReactConfirmAlert().warningAlert({
                     title: 'No se encontraron registros',
                    message: response.message
                })
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (hideLoading) hideLoading();
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
                if (hideLoading) hideLoading();
            },
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    const search = () => {
        const { route_segment_id, program_date_from, program_date_until } = masssiveCommissionChangeDataForm;

        const currentFilter: any = {
            route_segment_id,
            ...(program_date_from && { program_date_from }),
            ...(program_date_until && { program_date_until }),
        };

        setFilter(prev => ({ ...prev, ...currentFilter }));
    };


    return fetchingCreateMasssiveCommissionChangeDataForm ? (
            <LazyLoading height={300} />
        ) : (
            <>
                <MassiveCommissionChangeFilterForm 
                    masssiveCommissionChangeDataForm={masssiveCommissionChangeDataForm} 
                    setMasssiveCommissionChangeDataForm={setMasssiveCommissionChangeDataForm}
                    routeSegments={routeSegments}
                    currenciesCommission={currenciesCommission}
                    unitsCommission={unitsCommission}
                    errorFields={errorFields} 
                    onSearch={search}
                />

                <hr />

                <div className="row justify-content-end">
                    <div className="col-auto">
                        <ButtonCancelForm callbackCancel={cancel} locked={fetchingMasssiveCommissionChangeDataForm} />
                    </div>
                    <div className="col-auto">
                        <ButtonSaveForm callbackSave={update} locked={fetchingMasssiveCommissionChangeDataForm} />
                    </div>
                </div>
            </>
        );
};

export default MassiveCommissionChange;
